import { Link, graphql, useStaticQuery } from "gatsby"

import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { WhitepaperSignup } from "components/page-components/Signup-Forms"

export const EvergabeWhitepaper = () => {
  const data = useStaticQuery(graphql`
    {
      whitepaperMockup: file(
        relativePath: { eq: "evergabe-whitepaper-erste-vergabe-mockup.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 290
            layout: CONSTRAINED
            placeholder: BLURRED
            formats: [AUTO, AVIF]
          )
        }
      }
    }
  `)

  return (
    <div data-nosnippet className="container my-6">
      <div className="columns is-vcentered is-centered ">
        <div className="column is-7">
          <p className="title is-1 has-text-mitternachtsblau is-spaced">
            Erfahren Sie, wie der Start in die elektronische Vergabe zum Erfolg
            wird.
          </p>
          <p className="has-text-mitternachtsblau">
            Wie lassen sich Anfängerfehler vermeiden? <br />
            Wir haben die Antworten für Sie.
          </p>
          <WhitepaperSignup />
          <Link
            to={"/evergabe/wie-gelingt-die-erste-elektronische-vergabe"}
            className="link"
          >
            Was Sie im Whitepaper erwartet &rarr;
          </Link>
        </div>
        <div className="column is-5 has-text-centered">
          <div>
            <GatsbyImage
              alt="B_I eVergabe Whitepaper"
              image={data.whitepaperMockup.childImageSharp.gatsbyImageData}
              className="hoverzoom"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
